export default __webpack_public_path__ + "static/media/chevron-right-16.521a5dda.svg";